import React from "react"
import Layout from "../components/layout"

const Services = () => (
  <Layout>
    <div>
      <p>
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Esse iusto odio
        dolorem corrupti atque suscipit, tempore hic odit dolores velit repellat
        eum eaque veritatis magni doloremque explicabo earum harum ad.
      </p>
      <p>
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Esse iusto odio
        dolorem corrupti atque suscipit, tempore hic odit dolores velit repellat
        eum eaque veritatis magni doloremque explicabo earum harum ad.
      </p>
    </div>
  </Layout>
)

export default Services
